import { render, staticRenderFns } from "./CreateRoles.vue?vue&type=template&id=e15e6ac6&"
import script from "./CreateRoles.vue?vue&type=script&lang=js&"
export * from "./CreateRoles.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports